// extracted by mini-css-extract-plugin
module.exports = {"main":"vision-and-principles-module--main--1MG9q","seeMore":"vision-and-principles-module--seeMore--2Kf9r"};